import React, { ChangeEvent, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import { CheckboxBlockField, Chip } from 'components';
import { useDisplayablePriceList } from './utils/useDisplayablePriceList';
import { Offer, usePriceTiers } from '@app/api';
import { toEuros } from 'i18n';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  price: {
    marginRight: theme.marginBase,
  },
}));

interface Props {
  offer: Offer;
  duration: number;
  selected?: boolean;
  onSelect?: (e: ChangeEvent<HTMLDivElement>) => any;
}

export const OfferPriceTierBlock = ({
  offer,
  selected,
  onSelect,
  duration,
}: Props) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const { data: priceTiers } = usePriceTiers();

  const priceTier = useMemo(() => {
    return priceTiers?.find((p) => p.id === offer.requirement.priceThierId);
  }, [offer, priceTiers]);

  const prices = useDisplayablePriceList(offer?.prices, offer, duration);

  if (!priceTier) {
    return null;
  }

  const label = priceTier.maximum
    ? `${priceTier.minimum || 1} - ${priceTier.maximum}`
    : `${priceTier.minimum}+`;

  return (
    <CheckboxBlockField
      label={label}
      type="radio"
      variant="green"
      name="priceThierId"
      value={priceTier.id}
      trackingName="priceTier"
      checked={selected}
      onChange={onSelect}
    >
      {prices.map((priceObj, index) =>
        'label' in priceObj ? (
          <div />
        ) : (
          <div key={index} className={classes.content}>
            <div>{label}</div>
            <Chip key={priceObj.unit} color={selected ? 'green' : 'ink'}>
              <span className={classes.price}>
                {toEuros(priceObj.price, true, i18n.language)}
              </span>
              {i18n.exists(`billing.offers.block.units.${priceObj.unit}`) &&
                t(`billing.offers.block.units.${priceObj.unit}`)}
            </Chip>
          </div>
        ),
      )}
    </CheckboxBlockField>
  );
};
